import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const SuggestionTopContent = (_param)=>{
    var { className , cursor , suggestionTopContent , onClick , setHovered , setFocus  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "cursor",
        "suggestionTopContent",
        "onClick",
        "setHovered",
        "setFocus"
    ]);
    const onMouseEnter = React.useCallback(()=>setHovered('content')
    , [
        setHovered
    ]);
    const onMouseLeave = React.useCallback(()=>setHovered(undefined)
    , [
        setHovered
    ]);
    const onFocus = React.useCallback(()=>{
        setFocus(0);
    }, [
        setFocus
    ]);
    const onBlur = React.useCallback(()=>{
        setFocus(-1);
    }, [
        setFocus
    ]);
    const onClickHandler = React.useCallback((e)=>{
        if (e.currentTarget === document.activeElement && onClick) {
            e.preventDefault();
            onClick(e);
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ React.createElement("li", swcHelpers.extends({}, rest, {
        role: "presentation",
        className: classnames('suggestion-top-content', {
            'suggestion-top-content--active': cursor === 0
        }, className)
    }), /*#__PURE__*/ React.createElement("button", {
        id: "autocomplete-suggestion-item-0",
        role: "option",
        "aria-selected": cursor === 0,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClickHandler,
        className: "suggestion-top-content__button"
    }, suggestionTopContent));
};

export { SuggestionTopContent as default };
//# sourceMappingURL=SuggestionTopContent.js.map
